import { SquadCreateOrJoin } from '#src/components/squad/SquadCreateOrJoin/index.tsx';

const SquadCreateOrJoinPage = () => {
  return <SquadCreateOrJoin onJoin={() => {}} />;
};
export default SquadCreateOrJoinPage;
